module.exports = __webpack_public_path__ + "static/media/location-maps-letter-c.8b1f740d.png";